import React, { useState } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment
} from '@mui/material';
import { Search } from '@mui/icons-material';

const SearchableSelect = ({
  label,
  value,
  options,
  onChange,
  size = 'small',
  fullWidth = true,
  sx = {}
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [open, setOpen] = useState(false);

  const filteredOptions = options.filter(option =>
    String(option).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const highlight = (text, query) => {
    if (!query) return text;

    const parts = String(text).split(new RegExp(`(${query})`, 'gi'));

    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span
          key={index}
          style={{ fontWeight: 600, backgroundColor: '#fff3b0' }}
        >
          {part}
        </span>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  };

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={sx}>
      <InputLabel sx={{ fontSize: '0.75rem' }}>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={onChange}
        sx={{ fontSize: '0.75rem' }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 400,
              width: label === 'Customer' ? 260 : 200
            }
          }
        }}
      >
        <MenuItem sx={{ p: 0, fontSize: '0.75rem' }}>
          <TextField
            size='small'
            placeholder={`Search ${label}...`}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Search fontSize='small' />
                </InputAdornment>
              )
            }}
            sx={{
              fontSize: '0.75rem',
              '& .MuiOutlinedInput-root': {
                '& fieldset': { border: 'none' }
              }
            }}
          />
        </MenuItem>
        <MenuItem value='All' sx={{ fontSize: '0.75rem' }}>
          All
        </MenuItem>
        {searchTerm && filteredOptions.length > 0 && (
          <MenuItem disabled sx={{ opacity: 0.7, fontSize: '0.75rem' }}>
            Found {filteredOptions.length}{' '}
            {filteredOptions.length === 1 ? 'item' : 'items'}
          </MenuItem>
        )}

        {filteredOptions.length === 0 ? (
          <MenuItem disabled sx={{ opacity: 0.7, fontStyle: 'italic' }}>
            No results found
          </MenuItem>
        ) : (
          filteredOptions.map(option => (
            <MenuItem key={option} value={option} sx={{ fontSize: '0.75rem' }}>
              {highlight(option, searchTerm)}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default SearchableSelect;
